const textModule = {
  id: "b5884573-0c5f-31de-94e3-be1048c70f58",
  component: "CRText",
  config: {
    general: {
      template: {
        label: "Left Aligned, Top", // or "Left Aligned, Middle", "Left Aligned, Bottom", "Center Aligned, Top", "Center Aligned, Middle", "Center Aligned, Bottom"
        component: "TextLeftTop", // or "TextLeftMiddle", "TextLeftBottom", "TextCenterTop", "TextCenterMiddle", "TextCenterBottom"
      },
      blockWidth: {
        label: "1/3",
        value: "third",
      },
      paddings: {
        top: true,
        bottom: true,
      },
      backgroundColor: {
        label: "Cornsilk",
        value: "#fff8dc",
      },
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
        mediaType: "image",
      },
      showMedia: false,
      showText: true,
      showCtaButton: true,
      showHeader: true,
    },
    header: {
      text: "Be yourself & more.",
      isTextInCaps: false,
      textColor: {
        label: "Black",
        value: "#000000",
      },
    },
    text: {
      text: "We’re change agents and cyber gurus. Performance improvers and problem solvers. Data scientists and growth hackers ",
      textColor: {
        label: "Black",
        value: "#000000",
      },
    },
    ctaButton: {
      text: "Learn more",
      fillStyle: {
        label: "Fill",
        value: "fill",
      },
      corners: {
        label: "Round",
        value: "round",
      },
      link: {
        type: {
          label: "External Link",
          value: "external",
        },
        url: "https://www.example.com",
        scrollTarget: {
          label: "FAQ",
          value: "7c205826-8720-3b35-884d-b4aa2a32b7f9",
        },
        target: {
          label: "New Tab",
          value: "_blank",
        },
      },
      backgroundColor: {
        label: "Black",
        value: "#000",
      },
      textColor: {
        label: "Green",
        value: "#2bcd41",
      },
    },
  },
};

export default textModule;
